import Utils from '../utils/utils';

export default class RevertDefault {
  constructor(model, defaultModel) {
    this.model = model;
    this.defaultModel = defaultModel;
    this.utils = new Utils();
  }

  get isChanged() {
    return !this.isEquals;
  }

  get isEquals() {
    return angular.equals(this.model, this.defaultModel);
  }

  get defaultValue() {
    return this.defaultModel;
  }

  defaultValueFor(fieldName) {
    return this.defaultModel[fieldName];
  }

  revertToDefault() {
    return this.utils.deepCopy(this.model, this.defaultModel);
  }
}



// WEBPACK FOOTER //
// ./src/blocks/revert-default/revert-default.js